export const toPlain = (proxyObj) => JSON.parse(JSON.stringify(proxyObj));
